
import { Table } from "@/components/ui/table";
import { SchoolUser } from "@/types/users";
import { UserTableHeader } from "./table/UserTableHeader";
import { useUserStatus } from "./table/useUserStatus";
import { SearchBar } from "./table/SearchBar";
import { Pagination } from "./table/Pagination";
import { TableContent } from "./table/TableContent";
import { StatusFilter } from "./table/StatusFilter";

interface UserTableProps {
  users: SchoolUser[];
  loading: boolean;
  onDelete: (user: SchoolUser) => void;
  onUserUpdated: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  statusFilter: string | null;
  onStatusFilterChange: (status: string | null) => void;
}

export const UserTable = ({ 
  users, 
  loading, 
  onDelete, 
  onUserUpdated,
  searchQuery,
  onSearchChange,
  page,
  pageSize,
  totalCount,
  onPageChange,
  statusFilter,
  onStatusFilterChange,
}: UserTableProps) => {
  const { usersWithStatus } = useUserStatus(users);
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="relative space-y-4">
      <div className="flex items-center justify-between pb-4 gap-4">
        <StatusFilter 
          value={statusFilter}
          onChange={onStatusFilterChange}
        />
        <SearchBar 
          searchQuery={searchQuery} 
          onSearchChange={onSearchChange} 
        />
      </div>

      <Table>
        <UserTableHeader />
        <TableContent
          loading={loading}
          users={users}
          searchQuery={searchQuery}
          usersWithStatus={usersWithStatus}
          onDelete={onDelete}
          onUserUpdated={onUserUpdated}
        />
      </Table>

      <Pagination
        page={page}
        totalPages={totalPages}
        loading={loading}
        onPageChange={onPageChange}
      />
    </div>
  );
};
